var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-search-bar"})
}
var staticRenderFns = []

export { render, staticRenderFns }